module.exports = __webpack_public_path__ + "img/stories-easy.a2d64c0.svg";